import type {TextSectionFragmentType} from '@/modules/page/sanity/content-blocks/text-container/query';

import {INLINE_PORTABLE_TEXT_FRAGMENT} from '../inline-portable-text/query';

export const INLINE_BANNER_FRAGMENT = `//groq
	_type == "inlineBanner" => {
		...,
		description[]{
			${INLINE_PORTABLE_TEXT_FRAGMENT}
		}
	}
`;

export type InlineBannerFragment = Extract<
	NonNullable<TextSectionFragmentType['content']>[number],
	{_type: 'inlineBanner'}
>;
